import { times } from "lodash"
import createModule from "../createModule"
import view from "./view"
import { getData } from "./selectors/data"
import { getMetrics, getSelectedMetric } from "./selectors/metrics"
import { getItems } from "./selectors/items"
import { getDetailsItems, getDetailsData, getFactorsCategories, getTableDownloadData } from "./selectors/details"
import { getStatus } from "./selectors/status"
import { getPositionSet } from "helpers/comparison"
import { Creators } from "./model"
import { getStyleAggregation } from "selectors/styleAggregation"
import { Creators as PortfolioRootCreators } from "modules/portfolio-root/model"
import { VIEW_TYPES } from "helpers/base"
import { getFactorSensitivityQueryParams } from "helpers/factorSensitivity"
import { getCurrency } from "./selectors"
import { getFileName } from "modules/comparison/selectors/"
import { MODEL_METADATA_QUERY } from "resources/models"

export default createModule({
  view,
  externalProps: (state, props) => ({
    currency: getCurrency(state, props),
  }),
  required: ["account", "modelId", "positionSets", "startDate", "endDate", "factorSensitivityType"],
  data: [...times(5, (n) => {
    return {
      resource: `compareFactorSensitivity${n}`,
      as: null,
      passthrough: n > 0,
      url: ({ modelId, positionSets, startDate, endDate, base, viewType, factorSensitivityType, currency }) => {
        if (!positionSets[n] || positionSets[n].uploading) {
          return null
        }

        const positionSet = getPositionSet(positionSets, n, startDate)

        // If a segment is applied on the positionSet, use that segment on the base
        const baseCopy = { ...base }
        if (positionSet.segment) {
          baseCopy.segment = positionSet.segment
        }
        const baseKey = viewType === VIEW_TYPES.ACTIVE ? JSON.stringify(baseCopy) : ""

        return {
          id: `${modelId}${JSON.stringify(positionSet)}${startDate}${endDate}${baseKey}${factorSensitivityType}${currency}`,
          query: `query ($modelId: String!, $positionSet: PositionSetInput!, $base: [PositionSetInput], $from: Date!, $to: Date!, $factorSensitivityType: FactorSensitivityType!, $stdDev: PositiveFloat, $days: PositiveInt, $horizon: FactorSensitivityTimeHorizon!) {
                model (id: $modelId) {
                  simulation (positionSet: $positionSet, base: $base, from: $from, to: $to, interval: AUTO) {
                    factorSensitivity (type: $factorSensitivityType horizon: $horizon stdDev: $stdDev days: $days) {
                      date
                      factors {
                        id
                        name
                        category
                        value: sensitivity
                      }
                    }
                  }
                }
              }`,
          variables: {
            modelId,
            positionSet,
            from: startDate,
            to: endDate,
            base: viewType === VIEW_TYPES.ACTIVE ? [baseCopy] : undefined,
            ...getFactorSensitivityQueryParams(factorSensitivityType),
          },
        }
      },
    }
  }),
  MODEL_METADATA_QUERY,
  ],
  mapStateToProps: (state, props) => ({
    data: getData(state, props),
    metrics: getMetrics(state, props),
    items: getItems(state, props),
    detailsItems: getDetailsItems(state, props),
    detailsData: getDetailsData(state, props),
    selectedMetric: getSelectedMetric(state, props),
    status: getStatus(state, props),
    factorCategories: getFactorsCategories(state, props),
    ...getStyleAggregation(state, props),
    fileName: getFileName(state, props),
    tableDownloadData: getTableDownloadData(state, props),
  }),
  actions: {
    ...Creators,
    setAggregationFn: PortfolioRootCreators.setAggregationFn,
  },
})
